import { watch, onUnmounted, computed, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import { getLanguageDirection } from 'dashboard/components/widgets/conversation/advancedFilterItems/languages';

let watcherCount = 0;
let globalUnwatch = null;

export function useAppDir(watcher = false) {
  const { locale } = useI18n();

  const isRTL = computed(() => getLanguageDirection(locale.value));

  const updateAppDir = rtl => {
    if (window.nimchatConfig) {
      window.nimchatConfig.isRTLView = rtl;
    }
    document.documentElement.dir = rtl ? 'rtl' : 'ltr';
    document.documentElement.classList.toggle('app-rtl--wrapper', rtl);
  };

  if (watcher) {
    // Only create watcher if it's the first instance (first component that used this)
    if (watcherCount === 0) {
      // defer watcher registration to ensure locale is ready
      nextTick(() => {
        globalUnwatch = watch(isRTL, updateAppDir, { immediate: true });
      });
    }

    watcherCount += 1;

    onUnmounted(() => {
      watcherCount -= 1;
      // Only cleanup watcher when last component unmounts
      if (watcherCount === 0 && globalUnwatch) {
        globalUnwatch();
        globalUnwatch = null;
      }
    });
  }

  return { isRTL, updateAppDir };
}
